import { inject } from 'vue';
import { Translator } from 'js/shims-vue';
import { FileItem } from 'types/api/fileTypes';

interface UseFile {
    getFileName: (file: FileItem) => string;
    getFileSize: (fileSize: number) => string;
}

export function useFile(): UseFile {
    const $t = inject('$t') as Translator;

    const getFileName = (file: FileItem): string => {
        const maxLength = 20;
        if (file && file.name.length > maxLength) {
            return file.name.substring(0, maxLength) + '...' + file.extension;
        }
        return file.name + '.' + file.extension;
    };
    const getFileSize = (fileSize: number): string => {
        const kilobyte = 1024;
        const megabyte = kilobyte * kilobyte;

        if (fileSize < megabyte) {
            return $t.__('richtext.customoptions.AttachmentRichText.file_size.kilobytes', {
                fileSize: (fileSize / kilobyte).toFixed(2),
            });
        } else {
            return $t.__('richtext.customoptions.AttachmentRichText.file_size.megabytes', {
                fileSize: (fileSize / megabyte).toFixed(2),
            });
        }
    };
    return { getFileName, getFileSize };
}
